export default "__VITE_ASSET__1tXt5v_B__"